import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { LootBuyers } from './views/LootBuyers';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<LootBuyers />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.LootBuyers)
	.build();

export default Layout;
